import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";
import { extractAdditionalParamsFromTask } from "./midjourney";

export const elevenLabsExecutor = extractAdditionalParamsFromTask((jsonData, node) => {
	jsonData.inputs.push({
		name: "task_id",
		value: `${node.meta.taskID}`,
		type: "text"
	});
});

export const elevenLabsGetVoiceIdExecutor: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "voice_num",
				value: `${node.meta.fromAudioIndex + 1}`,
				type: "text"
			}
		);
	};
};
